module.exports = __webpack_public_path__ + "static/fonts/iconfont.0ef6f354.woff";